import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainPage from '../Pages/MainPage';
import TabMode from '../Enums/TabMode';

function MainPageRouter(): JSX.Element {
  
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<MainPage tabMode={TabMode.ORDERS} subView={null} />} />
                <Route path='/orders' element={<MainPage tabMode={TabMode.ORDERS} subView={null} />} />
                <Route path='/orders/:orderId' element={<MainPage tabMode={TabMode.ORDERS} subView={null} />} /> {/*would be better if the orderId could be sent as a prop directly, but don't think that is possible*/}
                <Route path='/settings' element={<MainPage tabMode={TabMode.SETTINGS} subView={null} />} />
                <Route path='/settings/about' element={<MainPage tabMode={TabMode.SETTINGS} subView='about' />} />
                <Route path='*' element={<MainPage tabMode={TabMode.ORDERS} subView={null} />} />
            </Routes>
        </BrowserRouter>
    );
}

export default MainPageRouter;